<template>

  <PagesDynamic path="/search" title="Search">

    <h1 class="sr-only">Search</h1>

    <section class="section">
      <div class="section__content section__content--search">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12 text-center-xl">
              <h3 class="text-black">
                Need <span class="text-yellow-ci">anything?</span>, just type
                the word!
              </h3>
            </div>
            <div class="col-lg-8">
              <form class="form form--search-popular">
                <div class="form-group">
                  <div class="search">
                    <input class="search__input" type="text" placeholder="What are you looking for?"
                      v-model="searchQuery" />
                    <span class="search__icon">
                      <i class="icon-search"></i>
                    </span>
                  </div>
                </div>
              </form>

              <ul class="nav nav--popular">
                <li class="nav-item nav-item--title">Popular search:</li>

                <template v-if="suggestions && suggestions.length">

                  <li class="nav-item" v-for="(item, i) in suggestions" :key="i">
                    <a class="nav-link" href="#" @click.prevent="addToSearch(item.query)">
                      {{ item.query }}
                    </a>
                  </li>

                </template>

                <template v-else>

                  <li class="nav-item">
                    <a class="nav-link" href="#" @click.prevent="addToSearch('Investor Relations')">Investor
                      Relations</a>
                  </li>

                  <li class="nav-item">
                    <a class="nav-link" href="#" @click.prevent="addToSearch('Material')">Material</a>
                  </li>

                  <li class="nav-item">
                    <a class="nav-link" href="#" @click.prevent="addToSearch('Report')">Report</a>
                  </li>

                  <li class="nav-item">
                    <a class="nav-link" href="#" @click.prevent="addToSearch('ESG')">ESG</a>
                  </li>

                  <li class="nav-item">
                    <a class="nav-link" href="#" @click.prevent="addToSearch('Shareinvestor')">Shareinvestor</a>
                  </li>

                  <li class="nav-item">
                    <a class="nav-link" href="#" @click.prevent="addToSearch('Cyber Security')">Cyber Security</a>
                  </li>

                </template>
              </ul>
            </div>
            <div class="col-lg-12">
              <p class="small text-gray-1">You Interesting...</p>
              <div class="interest-sorting">

                <button v-for="(type, index) in types" :key="index" type="button" :class="[
                  'interest-sorting__item',
                  { active: activeIndex === index || (activeIndex === null && index === 0) },
                ]" @click="setActive(index)">
                  {{ type }}
                </button>
              </div>

            </div>

            <div class="col-lg-12">

              <div class="search-result" v-show="activeIndex == 0 || activeIndex == null || activeIndex == 1">
                <div class="search-result__wrapper">
                  <div class="search-result__title">{{ types[1] }}</div>
                  <div class="search-result__sum">{{ filteredPages.length }}</div>
                </div>
                <div class="card-deck">

                  <template v-for="(item, i) in currentPages" :key="i">

                    <NuxtLink class="card card--search-result" :to="localePath(`${item.url}`)">
                      <div class="card__body">
                        <div class="card__title" v-html="textHighlight(item.title, searchQuery)"></div>
                        <div class="card__detail" v-html="textHighlight(item.excerpt || item.body, searchQuery)"></div>
                      </div>
                    </NuxtLink>

                  </template>

                </div>
                <div>

                  <Pagination v-model="pagePage" :page="currentPagePage" :totalPages="totalPages"
                    :totleItems="filteredPages.length" :itemPerPage="pagePerPage" />
                </div>
              </div>

              <div class="search-result" v-show="activeIndex == 0 || activeIndex == null || activeIndex == 2">
                <div class="search-result__wrapper">
                  <div class="search-result__title">{{ types[2] }}</div>
                  <div class="search-result__sum">{{ filteredPorts.length }}</div>
                </div>
                <div class="card-deck">

                  <template v-for="(item, i) in currentPorts" :key="i">

                    <NuxtLink class="card card--search-result" :to="item.external_url" target="_blank">
                      <div class="card__body">
                        <div class="card__image">
                          <img :src="item.image" alt="" />
                        </div>
                        <div class="card__title" v-html="textHighlight(item.title, searchQuery)"></div>
                        <div class="card__detail" v-html="textHighlight(item.excerpt || item.body, searchQuery)"></div>
                      </div>
                    </NuxtLink>

                  </template>

                </div>
                <div>

                  <Pagination v-model="portPage" :page="currentPortPage" :totalPages="totalPages"
                    :totleItems="filteredPorts.length" :itemPerPage="portPerPage" />
                </div>
              </div>

              <div class="search-result" v-show="activeIndex == 0 || activeIndex == null || activeIndex == 3">
                <div class="search-result__wrapper">
                  <div class="search-result__title">{{ types[3] }}</div>
                  <div class="search-result__sum">{{ filteredBlogs.length }}</div>
                </div>
                <div class="card-deck">

                  <template v-for="(item, i) in currentBlogs" :key="i">

                    <NuxtLink class="card card--search-result" :to="localePath(`/blogs/${item.id}/${item.slug}`)">
                      <div class="card__body">
                        <div class="card__image">
                          <img :src="item.image" alt="" />
                        </div>
                        <div class="card__title" v-html="textHighlight(item.title, searchQuery)"></div>
                        <div class="card__detail" v-html="textHighlight(item.body, searchQuery)"></div>
                      </div>
                    </NuxtLink>
                  </template>

                </div>
                <div>
                  <Pagination v-model="blogPage" :page="currentBlogPage" :totalPages="totalPages"
                    :totleItems="filteredBlogs.length" :itemPerPage="blogPerPage" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </PagesDynamic>
</template>

<script setup>

import { ref } from "vue";
import Pagination from "@/components/apps/Pagination.vue";
import debounce from 'lodash/debounce';

// รายการหมวดหมู่ปุ่ม
const types = ["All", "Site Search", "Portfolio", "Blog"];

// เก็บค่า index ของปุ่มที่ active
const activeIndex = ref(null);

// ฟังก์ชันสำหรับตั้งค่าปุ่มที่ active
const setActive = (index) => {
  activeIndex.value = index;
};

const searchQuery = ref('');
const debouncedSearchQuery = ref('');

const pages = ref([]);
const pagePage = ref(1);
const currentPagePage = ref(1);
const filteredPages = ref([]);
const pagePerPage = ref(3);

const currentPages = computed(() => {
  const startIndex = (pagePage.value - 1) * pagePerPage.value;
  const endIndex = startIndex + pagePerPage.value;
  return filteredPages.value.slice(startIndex, endIndex);
});

const pageSearch = async () => {

  const { search } = useAlgoliaSearch('pages');
  const data = await search({ query: '' });

  if (data.hits) {
    pages.value = data.hits;
    pages.value = pages.value.filter((item) => {
      return item.status == 'public' && !item.tags.find((tag) => tag.name.includes('hidden-search'))
    })
  }
}


const blogs = ref([]);
const blogPage = ref(1);
const currentBlogPage = ref(1);
const filteredBlogs = ref([]);
const blogPerPage = ref(3);

const currentBlogs = computed(() => {
  const startIndex = (blogPage.value - 1) * blogPerPage.value;
  const endIndex = startIndex + blogPerPage.value;
  return filteredBlogs.value.slice(startIndex, endIndex);
});

const blogSearch = async () => {

  const { search } = useAlgoliaSearch('posts');
  const data = await search({ query: '' });

  if (data.hits) {
    blogs.value = data.hits;
    blogs.value = blogs.value.filter((item) => {
      return item.status == 'public' && item.categories.includes('Blogs') && !item.tags.find((tag) => tag.name.includes('hidden-search'))
    })
  }
}

const suggestions = ref([]);

const suggestionSearch = async () => {

  const { search } = useAlgoliaSearch('posts_query_suggestions');
  const data = await search({ query: '' });

  if (data.hits) {
    suggestions.value = data.hits;
  }
}


const ports = ref([]);
const portPage = ref(1);
const currentPortPage = ref(1);
const filteredPorts = ref([]);
const portPerPage = ref(3);

const currentPorts = computed(() => {
  const startIndex = (portPage.value - 1) * portPerPage.value;
  const endIndex = startIndex + portPerPage.value;
  return filteredPorts.value.slice(startIndex, endIndex);
});

const portSearch = async () => {

  const { search } = useAlgoliaSearch('clients');
  const data = await search({ query: '' });

  if (data.hits) {
    ports.value = data.hits;
    ports.value = ports.value.filter((item) => {
      return item.status == 'public' && item.services.includes('Our Portfolio') && !item.tags.find((tag) => tag.name.includes('hidden-search'))
    })
  }
}

// Watch for searchQuery changes with debounce
watch(searchQuery, debounce((value) => {
  debouncedSearchQuery.value = value;
  applyFilters();
}, 300));

// Filter posts
const applyFilters = () => {

  const query = debouncedSearchQuery.value.toLowerCase();

  filteredBlogs.value = blogs.value.filter((post) => {
    const matchesQuery = query
      ? post.title.toLowerCase().includes(query) || post.excerpt.toLowerCase().includes(query) || post.body.toLowerCase().includes(query)
      : true;

    return matchesQuery;
  });

  filteredPages.value = pages.value.filter((page) => {
    const matchesQuery = query
      ? page.title.toLowerCase().includes(query) || page.excerpt.toLowerCase().includes(query) || page.body.toLowerCase().includes(query)
      : true;

    return matchesQuery;
  });

  filteredPorts.value = ports.value.filter((item) => {
    const matchesQuery = query
      ? item.services.find((cat) => cat.toLowerCase().includes(query)) ||
      item.title.toLowerCase().includes(query) ||
      item.excerpt.toLowerCase().includes(query)
      : true;

    return matchesQuery;
  });

  pagePage.value = 1
  blogPage.value = 1
  portPage.value = 1
  currentPagePage.value = 1
  currentBlogPage.value = 1
  currentPortPage.value = 1

};


const textHighlight = (html, keyword, getAll = true) => {

  if (html) {

    let position = html.toLowerCase().indexOf(keyword.toLowerCase());

    if (position != -1 && keyword != "") {
      let regEx = new RegExp(keyword, "ig");
      let newHtml = html.replace(regEx, function (str) {
        return `<mark>${str}</mark>`;
      });

      if (getAll) {
        return newHtml;
      } else {
        return newHtml.slice(position, position + 200);
      }
    } else {
      return html.slice(0, 200);
    }
  }

}

const addToSearch = (value) => {
  searchQuery.value = value;
};

onMounted(async () => {

  await pageSearch()
  await blogSearch()
  await portSearch()
  await suggestionSearch()

  applyFilters();

})


</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";

@each $lang in $languages {
  html[lang="#{$lang}"] {
    .interest-sorting {
      .interest-sorting__item {
        @include font-size("small", $lang);
      }
    }

    .nav {
      &.nav--popular {
        .nav-item--title {
          @include font-size("small", $lang);
          @include font-weight("semibold", $lang);
        }

        .nav-link {
          @include font-size("small", $lang);
        }
      }
    }
  }

  .search-result {
    padding: 48px 0 40px 0;

    .search-result__title {
      @include font-size("h5", $lang);
    }

    .search-result__sum {}
  }

  .card {
    &.card--search-result {
      .card__title {
        @include font-size("body-3", $lang);
        @include font-weight("semibold", $lang);
      }

      .card__detail {
        @include font-size("small", $lang);
        line-height: 1.7;
      }
    }
  }
}

.text-center-xl {
  @include media-breakpoint-up(xl) {
    text-align: center;
  }
}

.nav {
  &.nav--popular {
    justify-content: center;
    margin-bottom: 60px;

    .nav-item--title {
      color: $black;
      padding: 0 10px 0 0;
    }

    .nav-link {
      padding: 0 10px 0 0;
      color: $gray-1;

      @include hover-focus-active {
        color: $yellow-ci;
      }
    }
  }
}

.interest-sorting {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba($gray-1, 0.5);
  color: $black;

  .interest-sorting__item {
    padding: 0.5rem 1.25rem;
    border-radius: 20px;
    border: 1px solid $black;
    text-transform: uppercase;
    background-color: transparent;
    color: $black;
    cursor: pointer;
    @include transition();

    @include hover {
      background-color: $yellow-ci;
      border: 1px solid $yellow-ci;
    }

    &.active {
      background-color: $yellow-ci;
      border: 1px solid $yellow-ci;
    }
  }
}

.search-result {
  border-bottom: 1px solid rgba($gray-1, 0.5);

  .search-result__wrapper {
    display: flex;
    gap: 27px;
    align-items: center;
    margin-bottom: 10px;
  }

  .search-result__title {
    text-transform: uppercase;
    color: $black;
  }

  .search-result__sum {
    background-color: $black;
    color: $white;
    line-height: normal;
    display: flex;
    min-width: 40px;
    height: 40px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 100px;
  }

  ul.pagination {
    margin-top: 10px !important;
  }
}

.card {
  &.card--search-result {
    margin-top: 30px;
    margin-bottom: 30px;

    mark {
      background-color: rgba($yellow-ci, 0.5);
    }

    color: $black;

    .card__body {}

    .card__image {
        margin-bottom: 18px;
      
      img {
        border-radius: 20px;
        max-width: 100%;
      }
    }

    .card__title {
      margin-bottom: 8px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .card__detail {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}
</style>